export default __webpack_public_path__ + "static/media/select-check-active.4225a38a.svg";